import script from "./Inner.vue?vue&type=script&lang=ts&setup=true"
export * from "./Inner.vue?vue&type=script&lang=ts&setup=true"

import "./Inner.vue?vue&type=style&index=0&id=46a88fe6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a88fe6"]])

export default __exports__